let nrInstances: { id: number; name: string; domainName: string; }[] = [];

// TODO: This should be assigned in config or from API calls
if (process.env.VUE_APP_FRAMEWORK_HOST?.trim()?.toLowerCase() === 'connexin') {
  nrInstances = [
    { id: 1, name: 'Low Code 1', domainName: `fc1.fc.apps.connexin.co.uk`, },
  ];
} else {
  // TODO: Assign for checksight
}

export const noderedInstances: { id: number; name: string; domainName: string; }[] = nrInstances;